.text {
  color: var(--mirai-ui-content-light);
  margin-bottom: var(--mirai-ui-space-S);
}

.asterisk {
  color: var(--mirai-ui-error);
}
